import { Withdrawal as Component } from './Withdrawal';
import { withState } from './Withdrawal.state';

export const Withdrawal = withState(Component);
